{
  "$id": "wealthlane://forms/plan-management/rules",
  "$schema": "wealthlane://schemas/form-rules",
  "effects": [
    {
      "watch": "evergreenPlan",
      "condition": { "field": "evergreenPlan", "notEquals": "Yes" },
      "clear": ["evergreenCriteria"]
    },
    {
      "watch": "planTypeCategoryIds",
      "condition": { "field": "planTypeCategoryIds", "isEmpty": true },
      "clear": ["planTypeCategory"]
    }
  ],
  "observers": [
    {
      "id": "syncPlanTypeLabels",
      "watch": "planTypeCategoryIds",
      "condition": { "field": "planTypeCategoryIds", "notEmpty": true },
      "lookup": {
        "actionId": "RESOLVE_PLAN_TYPE_LABELS",
        "params": { "ids": "planTypeCategoryIds" },
        "rejectIfTouched": false
      },
      "mapTo": { "planTypeCategory": "planTypeCategory" },
      "debounceMs": 0
    }
  ]
}
